export default "__VITE_PUBLIC_ASSET__1710effa__"